// extracted by mini-css-extract-plugin
export default {"banner":"_1zFcZ","stage-notifications":"_3hYLU","stageNotifications":"_3hYLU"};